import Vue from 'vue'
import Vuex from 'vuex'
import api from './modules/api'
import menu from './modules/menu'
import slots from './modules/slots'
import basket from './modules/basket'
import snackbar from './modules/snackbar'
import schedule from './modules/schedule'
import guestAuth from './modules/guestAuth'
import mainButton from './modules/mainButton'
import deliveryAreas from './modules/deliveryAreas'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { api, menu, slots, basket, snackbar, schedule, guestAuth, mainButton, deliveryAreas }
})
